// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 28,
  argument: "Lessons against revenge and quarrels. The evils of the tongue.",
  verses: [
    { n: 1, text: "He that seeketh to revenge himself, shall find vengeance from the Lord, and he will surely keep his sins in remembrance." },
    { n: 2, text: "Forgive thy neighbour if he hath hurt thee: and then shall thy sins be forgiven to thee when thou prayest." },
    { n: 3, text: "Man to man reserveth anger, and doth he seek remedy of God?" },
    { n: 4, text: "He hath no mercy on a man like himself, and doth he entreat for his own sins?" },
    { n: 5, text: "He that is but flesh, nourisheth anger, and doth he ask forgiveness of God? who shall obtain pardon for his sins?" },
    { n: 6, text: "Remember thy last things, and let enmity cease:" },
    { n: 7, text: "For corruption and death hang over in his commandments." },
    { n: 8, text: "Remember the fear of God, and be not angry with thy neighbour." },
    { n: 9, text: "Remember the covenant of the most High, and overlook the ignorance of thy neighbour." },
    { n: 10, text: "Refrain from strife, and thou shalt diminish thy sins:" },
    { n: 11, text: "For a passionate man kindleth strife, and a sinful man will trouble his friends, and bring in debate in the midst of them that are at peace." },
    { n: 12, text: "For as the wood of the forest is, so the fire burneth: and as man's strength is, so shall his anger be, and according to his riches he shall increase his anger." },
    { n: 13, text: "A hasty contention kindleth a fire: and a hasty quarrel sheddeth blood: and a tongue that beareth witness bringeth death." },
    { n: 14, text: "If thou blow the spark, it shall burn as a fire: and if thou spit upon it, it shall be quenched: both come out of the mouth." },
    { n: 15, text: "The whisperer and the double-tongued is accursed: for he hath troubled many that were at peace." },
    { n: 16, text: "The tongue of a third person hath disquieted many, and scattered them from nation to nation." },
    { n: 17, text: "It hath destroyed the strong cities of the rich, and hath overthrown the houses of great men." },
    { n: 18, text: "It hath cut in pieces the forces of people, and undone strong nations." },
    { n: 19, text: "The tongue of a third person hath cast out valiant women, and deprived them of their labours." },
    { n: 20, text: "He that hearkeneth to it, shall never have rest, neither shall he have a friend in whom he may repose." },
    { n: 21, text: "The stroke of a whip maketh a blue mark: but the stroke of the tongue will break the bones." },
    { n: 22, text: "Many have fallen by the edge of the sword, but not so many as have perished by their own tongue." },
    { n: 23, text: "Blessed is he that is defended from a wicked tongue, that hath not passed into the wrath thereof, and that hath not drawn the yoke thereof, and hath not been bound in its bands." },
    { n: 24, text: "For its yoke is a yoke of iron: and its bands are bands of brass." },
    { n: 25, text: "The death thereof is a most evil death: and hell is preferable to it." },
    { n: 26, text: "Its continuance shall not be for a long time, but it shall possess the ways of the unjust: and the just shall not be burnt with its flame." },
    { n: 27, text: "They that forsake God shall fall into it, and it shall burn in them, and shall not be quenched, and it shall be sent upon them as a lion, and as a leopard it shall tear them." },
    { n: 28, text: "Hedge in thy ears with horns, hear not a wicked tongue, and make doors and bars to thy mouth." },
    { n: 29, text: "Melt down thy gold and silver, and make a balance for thy words, and a just bridle for thy mouth:" },
    { n: 30, text: "And take heed lest thou slip with thy tongue, and fall in the sight of thy enemies who lie in wait for thee, and thy fall be incurable unto death." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Sins. To seek revenge out of rancour, or contrary to justice, is a grievous sin. (Worthington) — Retaliation was tolerated, (Exodus xxi. 24.) but love was not to be laid aside, Deuteronomy xxxiii. 35., Leviticus xxi. 17., Psalm vii. 5., and Matthew vii. 2.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Forgive. This charity enforces, when the offender is penitent, if the remission of punishment be not contrary to justice and discipline. (Worthington) — Matthew vi. 12., and xviii. 32., and Luke vi. 37. We all stand in need of pardon.", attribution: "Calmet" }
    ] },
    { verse: 5, notes: [
      { text: "And doth. Greek, \"who will expiate his sins?\" Is God bound to receive his victims or prayers while he entertains such dispositions?", attribution: "Calmet" }
    ] },
    { verse: 7, notes: [
      { text: "In his commandments. Supply the sentence out of the Greek thus: Remember corruption and death, and abide in the commandments, (Challoner) which condemn revenge, Exodus xxiii. 4. (Calmet) — Complutensian, \"and do not rage or menace thy neighbour with destruction and death; yea, stick to the commandments. Be mindful of the precepts, and be not angry with thy neighbour; and of the covenant,\" &c.,", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Burneth. The more fuel, the greater will be the blaze.", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: "And a, &c., is not in Greek. Proverbs xix. 12., and xxvi. 21.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Third. Who carries stories between friends, to set them at variance.", attribution: "Calmet" }
    ] },
    { verse: 18, notes: [
      { text: "It, &c., is omitted in Greek. (Haydock) — Indiscreet reports often cause dissensions.", attribution: "Worthington" }
    ] },
    { verse: 19, notes: [
      { text: "Labours. Causing their husbands to suspect them.", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: "Their own. Greek, \"the.\" Detraction separates many friends.", attribution: "Calmet" }
    ] },
    { verse: 25, notes: [
      { text: "Hell. Or rather \"the grave.\"", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Its. Greek, \"it shall not take hold of the pious, and they shall not,\" &c. (Haydock) — Their virtue shall quickly shine forth.", attribution: "Calmet" }
    ] },
    { verse: 28, notes: [
      { text: "Hear. Greek, \"lo, hedge in thy possessions with thorns: bind up thy silver and gold.\" (Haydock) — To pay attention to detraction is as bad as to utter it.", attribution: "Worthington" }
    ] },
    { verse: 29, notes: [
      { text: "Just. Greek, \"a door and bolt,\" &c., as [in]", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "Tongue. Greek, \"by them, lest thou fall before him who lays snares,\" chap. xxix.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
